<div class="content-container min-height m-t-20" *ngIf="loaded; else loadWidget">

  <form [formGroup]="parentForm" (ngSubmit)="save()">

    <div class="ui-g">
      <div class="ui-g-12">
        <div class="main-topic-panel wsd-detail">
          <h2>{{ (getFullName() ? getFullName() : 'WS_DIRECTORY.PERSON_MODIFY.CREATE_PERSON') | translate }}</h2>
          <p-tabView>
            <p-tabPanel [header]=" 'WS_DIRECTORY.PERSON_MODIFY.HEADERS.GENERAL' | translate ">

              <!--              Synchronized data-->
              <div *ngIf="person.keyCloakId && isLoggedUser" class="ui-g m-b-0">
                <div class="ui-g-9">
                  <div class="ui-g">
                    <div class="ui-g-4">
                      <label>{{ 'SELECT_ORGANIZATION.LABEL' | translate }}</label>
                    </div>
                    <div class="ui-g-8 text-left m-t-10">
                      {{ person?.organization?.name }}
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-4">
                      <label>{{ 'SELECT_COUNTRY.LABEL' | translate }}</label>
                    </div>
                    <div class="ui-g-8 text-left m-t-10">
                      {{ person?.country?.name }}
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-4">
                      <label>{{ 'SELECT_REGION.LABEL' | translate }}</label>
                    </div>
                    <div class="ui-g-8 text-left m-t-10">
                      {{ person?.region?.name }}
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-4">
                      <label>{{ 'SELECT_WORKING_LANGUAGE.LABEL' | translate }}</label>
                    </div>
                    <div class="ui-g-8 text-left m-t-10">
                      {{ person?.language?.name }}
                    </div>
                  </div>
                  <div class="ui-g" *gsShowIfHasPermission="['ROLES_READ']">
                    <div class="ui-g-4">
                      <label>{{ 'SELECT_ROLE.LABEL' | translate }}</label>
                    </div>
                    <div class="ui-g-8 text-left m-t-10">
                      {{ stringifyRoles(person?.roles)}}
                    </div>
                  </div>
                  <div class="ui-g p-b-10">
                    <div class="ui-g-offset-4 ui-g-8">
                      <a href="{{idmAccountUrl}}">
                        <button pButton
                                type="button"
                                class="link-button"
                                label="{{ 'WS_DIRECTORY.PERSON_MODIFY.EDIT_YOUR_DATA_BUTTON' | translate }}">
                        </button>
                      </a>
                    </div>
                  </div>
                  <!--                    <div *gsShowIfHasPermission="['WSD_IDM_PROFILE_UPDATE']">-->
                  <!--                      <div *ngIf="!isLoggedUser" class="ui-g m-t-10">-->
                  <!--                        <div class="ui-g-offset-4 ui-g-8">-->
                  <!--                          <a href="{{idmConsoleUrl + person?.keyCloakId}}">-->
                  <!--                            <button pButton-->
                  <!--                                    type="button"-->
                  <!--                                    class="link-button"-->
                  <!--                                    label="{{ 'WS_DIRECTORY.PERSON_MODIFY.EDIT_OTHER_PERSON_DATA_BUTTON' | translate }}">-->
                  <!--                            </button>-->
                  <!--                          </a>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                </div>
                <div class="ui-g-3" style="position: relative;">
                  <div class="image-holder" *ngIf="person.keyCloakId && !imageSrc">
                    <img *ngIf="!person.profileImageURL" src="../../../assets/images/no_image.png">
                    <img *ngIf="person.profileImageURL" [src]="person.profileImageURL">
                    <p-fileUpload  #fileUpload
                                  mode="basic"
                                  chooseLabel="{{ 'WS_DIRECTORY.PERSON_MODIFY.LOAD_LOGO_BTN_LABEL' | translate }}"
                                  accept="image/*"
                                  [maxFileSize]="5000000"
                                  (onSelect)="onSelect($event)">
                    </p-fileUpload>
                  </div>
                  <div *ngIf="person.keyCloakId && imageSrc" class="image-holder" >
                    <img src="../../../assets/images/no_image.png" *ngIf="!imageSrc">
                    <img [src]="imageSrc" *ngIf="imageSrc">
                    <button  type="button"
                            pButton
                            (click)="removeImage()"
                            class="ui-button-danger remove"
                            icon="fa fa-times">
                    </button>
                    <p-fileUpload  #fileUpload
                                  mode="basic"
                                  chooseLabel="{{ 'WS_DIRECTORY.PERSON_MODIFY.LOAD_LOGO_BTN_LABEL' | translate }}"
                                  accept="image/*"
                                  [maxFileSize]="5000000"
                                  (onSelect)="onSelect($event)">
                    </p-fileUpload>
                  </div>
                </div>
              </div>

              <div class="ui-g">
                <div class="ui-g-9">
                  <div class="ui-g" *gsShowIfHasPermission="['TITLE_UPDATE'];consultantId: person.id">
                    <div class="ui-g-4">
                      <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.TITLE' | translate }}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-extended-input [control]="parentForm.get('title')">
                        <input pInputText formControlName="title">
                      </wsd-extended-input>
                    </div>
                  </div>
                  <div [hidden]="isLoggedUser">
                    <div class="ui-g" *gsShowIfHasPermission="['FIRST_NAME_UPDATE'];consultantId: person.id">
                      <div class="ui-g-4">
                        <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.FIRST_NAME' | translate }}</label>
                      </div>
                      <div class="ui-g-8">
                        <wsd-extended-input [control]="parentForm.get('firstName')">
                          <input pInputText formControlName="firstName">
                        </wsd-extended-input>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g" *gsShowIfHasPermission="['MIDDLE_NAME_UPDATE'];consultantId: person.id">
                    <div class="ui-g-4">
                      <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.MIDDLE_NAME' | translate }}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-extended-input [control]="parentForm.get('middleName')">
                        <input pInputText formControlName="middleName">
                      </wsd-extended-input>
                    </div>
                  </div>
                  <div [hidden]="isLoggedUser">
                    <div class="ui-g" *gsShowIfHasPermission="['LAST_NAME_UPDATE'];consultantId: person.id">
                      <div class="ui-g-4">
                        <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.LAST_NAME' | translate }}</label>
                      </div>
                      <div class="ui-g-8">
                        <wsd-extended-input
                          [control]="parentForm.get('lastName')">
                          <input pInputText formControlName="lastName">
                        </wsd-extended-input>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g" *gsShowIfHasPermission="['INITIALS_UPDATE'];consultantId: person.id">
                    <div class="ui-g-4">
                      <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.INITIALS' | translate }}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-extended-input [control]="parentForm.get('initials')">
                        <input pInputText formControlName="initials">
                      </wsd-extended-input>
                    </div>
                  </div>
                  <div class="ui-g" *gsShowIfHasPermission="['HONOURS_UPDATE'];consultantId: person.id">
                    <div class="ui-g-4">
                      <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.HONOURS' | translate }}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-extended-input [control]="parentForm.get('honours')">
                        <input pInputText formControlName="honours">
                      </wsd-extended-input>
                    </div>
                  </div>
                  <div class="ui-g" *gsShowIfHasPermission="['SUFFIX_UPDATE'];consultantId: person.id">
                    <div class="ui-g-4">
                      <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.SUFFIX' | translate }}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-extended-input [control]="parentForm.get('suffix')">
                        <input pInputText formControlName="suffix">
                      </wsd-extended-input>
                    </div>
                  </div>
                  <div class="ui-g" *gsShowIfHasPermission="['GENDER_UPDATE'];consultantId: person.id">
                    <div class="ui-g-4">
                      <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.GENDER.LABEL' | translate }}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-extended-input [control]="parentForm.get('gender')">
                        <p-radioButton [label]=" 'WS_DIRECTORY.PERSON_MODIFY.GENDER.TYPES.MALE' | translate "
                                       value="MALE"
                                       name="gender"
                                       formControlName="gender"
                                       class="m-r-15 inline-block">
                        </p-radioButton>
                        <p-radioButton [label]=" 'WS_DIRECTORY.PERSON_MODIFY.GENDER.TYPES.FEMALE' | translate "
                                       value="FEMALE"
                                       name="gender"
                                       formControlName="gender"
                                       class="m-r-15 inline-block">
                        </p-radioButton>
                        <p-radioButton
                          [label]=" 'WS_DIRECTORY.PERSON_MODIFY.GENDER.TYPES.OTHER_IDENTITY' | translate "
                          value="OTHER_IDENTITY"
                          name="gender"
                          formControlName="gender"
                          class="inline-block">
                        </p-radioButton>
                      </wsd-extended-input>
                    </div>
                    <div class="ui-g-8 ui-g-offset-4" *ngIf="parentForm.get('gender').value === 'OTHER_IDENTITY'">
                      <wsd-extended-input [control]="parentForm.get('genderDescription')">
                        <input pInputText
                               [placeholder]=" 'WS_DIRECTORY.PERSON_MODIFY.GENDER.DESCRIPTION_PLACEHOLDER' | translate "
                               formControlName="genderDescription">
                      </wsd-extended-input>
                    </div>
                  </div>
                  <div [hidden]="isLoggedUser">
                    <div *ngIf="person.keyCloakId" class="ui-g">
                      <div class="ui-g-4 info-icon">
                        <i class="pi pi-info"></i>
                      </div>
                      <div class="ui-g-8 info-text">
                        Synchronised person, Regional information is being pulled from scout.org IDM.
                      </div>
                    </div>
                    <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_UPDATE']">
                      <div class="ui-g-4">
                        <label>{{ 'SELECT_ORGANIZATION.LABEL' | translate}}</label>
                      </div>
                      <div class="ui-g-8">
                        <wsd-select-organization-ac [showLabel]="false"
                                                    [parentForm]="parentForm"></wsd-select-organization-ac>
                      </div>
                    </div>
                    <div class="ui-g" *gsShowIfHasPermission="['COUNTRY_TERRITORY_UPDATE']">
                      <div class="ui-g-4">
                        <label>{{ 'SELECT_COUNTRY.LABEL' | translate}}</label>
                      </div>
                      <div class="ui-g-8">
                        <wsd-select-country
                          [isDisabled]="person.id && person.keyCloakId !== null"
                          [showLabel]="false"
                          [parentForm]="parentForm"
                        ></wsd-select-country>
                      </div>
                    </div>
                    <div class="ui-g" *gsShowIfHasPermission="['REGION_PERSON_UPDATE']">
                      <div class="ui-g-4">
                        <label>{{ 'SELECT_REGION.LABEL' | translate}}</label>
                      </div>
                      <div class="ui-g-8">
                        <wsd-select-region
                          [isDisabled]="person.id && person.keyCloakId !== null"
                          [showLabel]="false"
                          [parentForm]="parentForm"></wsd-select-region>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-4">
                      <label>{{ 'SELECT_OFFICIAL_LANGUAGE.LABEL' | translate}}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-select-language-ac [allowedLanguages]="languageFilters.global"
                                              [controlName]="'officialLanguage'"
                                              [parentForm]="parentForm">
                      </wsd-select-language-ac>
                    </div>
                  </div>
                  <div *ngIf="!isLoggedUser" class="ui-g">
                    <div class="ui-g-4">
                      <label>{{ 'SELECT_WORKING_LANGUAGE.LABEL' | translate}}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-select-language-ac [parentForm]="parentForm"
                                              [allowedLanguages]="languageFilters.working"
                                              [controlName]="'workingLanguage'">
                      </wsd-select-language-ac>
                    </div>
                  </div>
                  <div *ngIf="person.editableRoles">
                    <div class="ui-g"
                         *gsShowIfHasPermission="['ROLES_UPDATE']">
                      <div class="ui-g-4">
                        <label>{{ 'SELECT_ROLE.LABEL' | translate}}</label>
                      </div>
                      <div class="ui-g-8">
                        <wsd-select-roles
                          [regionId]="person.region?.id"
                          [organizationId]="person.organization?.id"
                          [showLabel]="false"
                          [parentForm]="parentForm">
                        </wsd-select-roles>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g"
                       *gsShowIfHasPermission="['PORTFOLIO_AREAS_OF_EXPERTISE_UPDATE'];consultantId: person.id">
                    <div class="ui-g-4">
                      <label>{{ 'SELECT_EXPERTISE_AREA.LABEL' | translate}}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-select-expertise-areas [showLabel]="false"
                                                  [parentForm]="parentForm"></wsd-select-expertise-areas>
                    </div>
                  </div>
                  <div class="ui-g" *gsShowIfHasPermission="['COMMENT_UPDATE']">
                    <div class="ui-g-4">
                      <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.COMMENT' | translate }}</label>
                    </div>
                    <div class="ui-g-8">
                      <wsd-extended-input [control]="parentForm.get('comment')">
                        <textarea pInputTextarea
                                  autoResize="true"
                                  formControlName="comment"
                                  resizable="true">
                        </textarea>
                      </wsd-extended-input>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-4">
                      <label>{{ 'WS_DIRECTORY.PERSON_MODIFY.EMPLOYEE' | translate }}</label>
                    </div>
                    <div class="ui-g-8">
                      <p-checkbox formControlName="employee"
                                  binary="true"
                                  class="m-t-10">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
                <div *ngIf="!person.keyCloakId" class="ui-g-3" style="position: relative;">
                  <div class="image-holder"
                       *gsShowIfHasPermission="['PROFILE_IMAGE_READ'];consultantId: person.id">
                    <img src="../../../assets/images/no_image.png" *ngIf="!imageSrc">
                    <img [src]="imageSrc" *ngIf="imageSrc">
                    <button *gsShowIfHasPermission="['PROFILE_IMAGE_UPDATE'];consultantId: person.id" type="button"
                            pButton
                            (click)="removeImage()"
                            class="ui-button-danger remove"
                            icon="fa fa-times">
                    </button>
                    <p-fileUpload *gsShowIfHasPermission="['PROFILE_IMAGE_UPDATE'];consultantId: person.id" #fileUpload
                                  mode="basic"
                                  chooseLabel="{{ 'WS_DIRECTORY.PERSON_MODIFY.LOAD_LOGO_BTN_LABEL' | translate }}"
                                  accept="image/*"
                                  [maxFileSize]="5000000"
                                  (onSelect)="onSelect($event)">
                    </p-fileUpload>
                  </div>
                </div>
                <div *ngIf="person.keyCloakId && !isLoggedUser" class="ui-g-3" style="position: relative;">
                  <div class="image-holder"
                       *gsShowIfHasPermission="['PROFILE_IMAGE_READ'];consultantId: person.id">
                    <div *ngIf="!imageSrc">
                      <img src="../../../assets/images/no_image.png" *ngIf="!person.profileImageURL">
                      <img [src]="person.profileImageURL" *ngIf="person.profileImageURL">
                      <p-fileUpload *gsShowIfHasPermission="['PROFILE_IMAGE_UPDATE'];consultantId: person.id" #fileUpload
                                    mode="basic"
                                    chooseLabel="{{ 'WS_DIRECTORY.PERSON_MODIFY.LOAD_LOGO_BTN_LABEL' | translate }}"
                                    accept="image/*"
                                    [maxFileSize]="5000000"
                                    (onSelect)="onSelect($event)">
                      </p-fileUpload>
                    </div>
                    <div *ngIf="imageSrc">
                      <img src="../../../assets/images/no_image.png" *ngIf="!imageSrc">
                      <img [src]="imageSrc" *ngIf="imageSrc">
                      <button *gsShowIfHasPermission="['PROFILE_IMAGE_UPDATE'];consultantId: person.id" type="button"
                              pButton
                              (click)="removeImage()"
                              class="ui-button-danger remove"
                              icon="fa fa-times">
                      </button>
                      <p-fileUpload *gsShowIfHasPermission="['PROFILE_IMAGE_UPDATE'];consultantId: person.id" #fileUpload
                                    mode="basic"
                                    chooseLabel="{{ 'WS_DIRECTORY.PERSON_MODIFY.LOAD_LOGO_BTN_LABEL' | translate }}"
                                    accept="image/*"
                                    [maxFileSize]="5000000"
                                    (onSelect)="onSelect($event)">
                      </p-fileUpload>
                    </div>
                  </div>
                </div>
              </div>
            </p-tabPanel>


            <p-tabPanel [header]=" 'WS_DIRECTORY.PERSON_MODIFY.HEADERS.CONTACTS' | translate "
                        *gsShowIfHasPermission="['CONTACTS_PERSON_UPDATE'];consultantId: person.id">
              <wsd-contacts
                [countryId]="countryId"
                [addresses]="person.addresses"
                [contacts]="person.contacts"
                [isOrganization]=false
              >
              </wsd-contacts>
            </p-tabPanel>

            <p-tabPanel [header]=" 'WS_DIRECTORY.PERSON_MODIFY.HEADERS.APPOINTMENTS' | translate "
                        *gsShowIfHasPermission="['APPOINTMENTS_INCL_DIRECTORY_TITLES_UPDATE']">
              <wsd-appointments-person
                [emails]="getEmails()"
                [appointments]="person.appointments">
              </wsd-appointments-person>
            </p-tabPanel>

          </p-tabView>

          <hr>

          <div class="ui-g m-b-0">

            <div class="ui-g-12">

              <button pButton
                      type="submit"
                      class="ui-button-success fright m-l-15"
                      [disabled]="isSaveDisabled"
                      [label]=" 'WS_DIRECTORY.'+(person.id ? 'PERSON_MODIFY' : 'PERSON_CREATE')+'.SAVE_BUTTON' | translate ">
              </button>

              <button pButton
                      type="button"
                      class="ui-button-secondary"
                      [label]=" 'WS_DIRECTORY.ORG_MODIFY.BACK_BUTTON' | translate "
                      (click)="discard()">
              </button>

            </div>

          </div>
        </div>


      </div>
    </div>


  </form>
</div>

<ng-template #loadWidget>
  <div class="text-center m-b-30">
    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
  </div>
</ng-template>

<p-confirmDialog appendTo="body" icon="fa fa-question-circle" [style]="{width: '425px'}"></p-confirmDialog>
